import { useContext } from 'react';

import BuildingDetailsContext, { BuildingDetailsValues } from './context';

const useBuildingDetails = (): BuildingDetailsValues => useContext(BuildingDetailsContext);

export default useBuildingDetails;
